// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#toast-container {
    margin-top: 1rem;
    position: fixed;
    top: 1rem;
    right: 1rem;
    left: unset !important;
}

.toast-warning {
    flex-direction: row-reverse;
}

.toast-message {
    font-size: 1.8rem !important;
}

button.toast-close-button {
    top: -4px;
    right: -4px;
    font-size: 34px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/helpers/toastr-helper/ToastsHelper.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,WAAW;IACX,eAAe;AACnB","sourcesContent":["#toast-container {\r\n    margin-top: 1rem;\r\n    position: fixed;\r\n    top: 1rem;\r\n    right: 1rem;\r\n    left: unset !important;\r\n}\r\n\r\n.toast-warning {\r\n    flex-direction: row-reverse;\r\n}\r\n\r\n.toast-message {\r\n    font-size: 1.8rem !important;\r\n}\r\n\r\nbutton.toast-close-button {\r\n    top: -4px;\r\n    right: -4px;\r\n    font-size: 34px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
